import 'react-big-calendar/lib/css/react-big-calendar.css';
import { PageHeader } from 'antd';
import {
  HSMSCalendar,
  HSMSLoading,
  HSMSPageHeaderWrapper,
  HSMSStepContentCard,
  PageBreadcrumbs,
} from '@components/shared';
import { ViewTimetableProps } from '@modules/timetable';
import React from 'react';

export const ViewTimetable = ({ timetableCalendarItems, timetableDataLoading, userId }: ViewTimetableProps) => {
  // Set the timeline loading screen height
  let loadingScreenHeight = 0;

  const timelineElement = document.getElementsByClassName('rbc-time-view');
  if (!loadingScreenHeight && timelineElement instanceof HTMLElement) {
    loadingScreenHeight = timelineElement.offsetHeight;
  }

  return (
    <>
      <HSMSPageHeaderWrapper>
        <PageHeader title="Timetable" subTitle="Personal timetable" />
      </HSMSPageHeaderWrapper>

      <PageBreadcrumbs
        paths={[
          {
            pathName: 'Timetable',
            url: '/timetable',
          },
        ]}
      />

      {timetableDataLoading ? (
        <HSMSLoading height={loadingScreenHeight || 100} />
      ) : (
        <>
          <HSMSStepContentCard>
            <div className="hsms-card-body">
              <HSMSCalendar timetableCalendarItems={timetableCalendarItems || []} userId={userId} />
            </div>
          </HSMSStepContentCard>
        </>
      )}
    </>
  );
};
